/**
 * Secondary Firebase app for customer Auth (kingspark-app).
 * Staff POS Auth stays on the primary app in lib/firebase.ts.
 */

import { FirebaseApp, getApp, getApps, initializeApp } from 'firebase/app';
import { Auth, getAuth } from 'firebase/auth';
import { Functions, getFunctions } from 'firebase/functions';
import { config } from './config';

const CUSTOMER_APP_NAME = 'kingspark-customer-app';

function customerAppConfigured(): boolean {
  const c = config.customerAppFirebase;
  return Boolean(c.apiKey && c.authDomain && c.projectId && c.appId);
}

export function isCustomerAppAuthConfigured(): boolean {
  return customerAppConfigured();
}

export function getCustomerAppFirebase(): FirebaseApp {
  if (!customerAppConfigured()) {
    throw new Error(
      'Customer app Firebase is not configured. Set VITE_CUSTOMER_APP_FIREBASE_* env vars.',
    );
  }
  const existing = getApps().find((a) => a.name === CUSTOMER_APP_NAME);
  if (existing) return existing;
  try {
    return getApp(CUSTOMER_APP_NAME);
  } catch {
    const c = config.customerAppFirebase;
    return initializeApp(
      {
        apiKey: c.apiKey,
        authDomain: c.authDomain,
        projectId: c.projectId,
        storageBucket: c.storageBucket,
        messagingSenderId: c.messagingSenderId,
        appId: c.appId,
      },
      CUSTOMER_APP_NAME,
    );
  }
}

export function getCustomerAppAuth(): Auth {
  return getAuth(getCustomerAppFirebase());
}

/** Callables on kingspark-app (e.g. linkPosCustomerProfile). */
export function getCustomerAppFunctions(): Functions {
  return getFunctions(getCustomerAppFirebase(), 'us-central1');
}
